import { Collapse, Fade, Slide } from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import React, { cloneElement, useState } from 'react'
import { usePrevious } from 'src/hooks'

function withFrozenExit<T extends TransitionProps, U extends React.Attributes>(
  TransitionComponent: React.ComponentType<T>,
) {
  return function WrappedTransition({
    children,
    ...rest
  }: T & { children: React.ReactElement<U> }): React.ReactElement<T> {
    const [frozenNode, setFrozenNode] = useState<
      React.ReactElement | undefined
    >(undefined)
    const previousNode = usePrevious(children)
    const nodeToUse = frozenNode ?? children

    return (
      <TransitionComponent
        {...(rest as T)}
        onExit={(node: HTMLElement): void => {
          setFrozenNode(previousNode)
          rest.onExit?.(node)
        }}
        onEnter={(node: HTMLElement, isAppearing: boolean): void => {
          setFrozenNode(undefined)
          rest.onEnter?.(node, isAppearing)
        }}
      >
        {cloneElement(nodeToUse, {})}
      </TransitionComponent>
    )
  }
}

export const CollapseWithFrozenExit = withFrozenExit(Collapse)
export const SlideWithFrozenExit = withFrozenExit(Slide)
export const FadeWithFrozenExit = withFrozenExit(Fade)
